export const initialState = {
    users:{
        userData: {},
        isPermission: false,
        isDashboardLoaded: false,
    }
}
